import { ReactNode } from "react";
import { useSession } from "next-auth/react";
import { cn } from "@/lib/utils";

interface Props {
  steps: any[];
  activeStep: number;
}

export default function QuoteTabBar(props: Props) {
  const { steps, activeStep } = props;
  const { status } = useSession();

  function getVisibleSteps() {
    if (status === "authenticated") {
      // auth users only see the combined screen, then jump to Thanks
      return steps.slice(0, 1);
    }
    // unauthenticated users go through: Combined → Register → Interest → Gender → Thanks
    return steps.slice(0, steps.length - 1);
  }

  const visibleSteps = getVisibleSteps();

  function getTitle(): string {
    return steps[activeStep]?.title ?? "";
  }

  function getDescription(): string | ReactNode {
    return steps[activeStep]?.description ?? "";
  }

  return (
    <div className="w-full backdrop-blur-lg flex-col justify-center items-start gap-4 inline-flex">
      <div className="flex flex-row gap-1 w-full">
        {visibleSteps.map((_, index) => (
          <div
            key={index}
            className={cn(
              "w-full h-1.5 rounded-[8px]",
              index < activeStep && "bg-[#15bbae]",
              index === activeStep && "bg-primary",
              index > activeStep && "bg-assistant-secondary",
            )}
          />
        ))}
      </div>

      <div className="flex flex-col gap-2 w-full">
        <h1 className="text-slate-800 text-[28px] md:text-[32px] font-bold">
          {getTitle()}
        </h1>

        <h2 className="text-gray-400 text-sm font-medium leading-snug">
          {getDescription()}
        </h2>
      </div>
    </div>
  );
}
